import { localesQueryKeys as e } from "./useLocalesQueryKeys.mjs";
import { useQuery as t } from "@maat/store-hooks";
import { localesApi as n } from "@maat/api-main";
//#region src/locales/useLocales.ts
var r = () => t({
	queryKey: e.list(),
	queryFn: async () => n.getLocales()
});
//#endregion
export { r as useLocales };
